import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { useAuth } from '../contexts/AuthContext';

const OrgSwitcher: React.FC = () => {
  const { activeOrg, orgs, switchOrg } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  if (orgs.length <= 1) {
    // Single org — show name as static text
    return activeOrg ? (
      <Typography variant="body2" sx={{ fontWeight: 500, mx: 1 }}>
        {activeOrg.name}
      </Typography>
    ) : null;
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSwitch = async (orgId: number) => {
    handleClose();
    if (orgId !== activeOrg?.id) {
      await switchOrg(orgId);
    }
  };

  return (
    <>
      <Button
        onClick={handleClick}
        size="small"
        endIcon={<UnfoldMoreIcon />}
        sx={{
          textTransform: 'none',
          fontWeight: 500,
          color: 'text.primary',
          minHeight: 36,
          mx: 1,
        }}
        aria-label="Switch organization"
        aria-haspopup="true"
        aria-expanded={open}
      >
        {activeOrg?.name || 'Select org'}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{ paper: { sx: { minWidth: 200 } } }}
      >
        {orgs.map((org) => (
          <MenuItem
            key={org.id}
            onClick={() => handleSwitch(org.id)}
            selected={org.id === activeOrg?.id}
          >
            <ListItemText>{org.name}</ListItemText>
            {org.id === activeOrg?.id && (
              <ListItemIcon sx={{ minWidth: 'auto', ml: 1 }}>
                <CheckIcon fontSize="small" color="primary" />
              </ListItemIcon>
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default OrgSwitcher;
